import { useTranslation } from "react-i18next";
import { Form, Icon, Popup } from "semantic-ui-react";

import { Can } from "components";
import { Element } from "components/ReactScroll/index";
import ENV from "config/Env";
import { createFormHelper } from "lib/Form";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import "modules/CommunicationSettings/CustomerCom.scss";

import type { CommunicationSetting } from "models";

type DeskCheckInProps = {
  tabId: string;
};

const FormHelper = createFormHelper<CommunicationSetting>();

export const DeskCheckIn = ({ tabId }: DeskCheckInProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="customer-com-wrapper">
      <h3>{t("v8_desk_check_in", "Desk Check-in")}</h3>
      <div>
        <Form.Group className="mt-22 file">
          <Can I={ACL_ACTIVITIES.Create} the={ACL_RESOURCES.Files}>
            <Form.Field width={8} className="pr-12">
              <label className="small">
                <span>{t("v8_upload_start_image", "Upload start image")} (.jpg, .jpeg, .png)</span>
                <Popup
                  content={t("v8_min_size_of_desk_checkin_image", "Min size of Desk check-in start image")}
                  position="right center"
                  size="mini"
                  trigger={<Icon className="circle info" />}
                />
              </label>
              <FormHelper.Field.UploadImage path="/settings/welcome_pic/upload" baseUrl={ENV.deskBaseURL} name="counter_tablet_home_url" fileFieldName="file" />
            </Form.Field>
          </Can>
          <Form.Field width={8}>
            <p className="items-center">
              <FormHelper.Field.Checkbox
                name="is_customer_ok_read_only_in_desk_check_in"
                label={t("v8_customer_ok_read_only_in_desk_check_in", "Make Customer OK status read only")}
              />
            </p>
            <p className="items-center">
              <FormHelper.Field.Checkbox
                name="is_desk_contact_info_enabled"
                label={t("v8_Show_contact_info_modal_on_Desk_check_in", "Show contact info modal on Desk check-in")}
              />
            </p>
          </Form.Field>
        </Form.Group>
      </div>
    </Element>
  );
};
